import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "src/store/actions/action";
import { AsVo } from "src/vo/asVo";
import styled from "styled-components";
import HomeBgItem from "./HomeBgItem";

const ComEstimateItem = () => {
  const [isRequest, setIsRequest] = useState(true);

  const asList: any = useAppSelector((state) => state.homeReduce.asDataList);

  useEffect(() => {
    if (asList) {
      if (asList.length > 0) {
        setIsRequest(true);
      } else {
        setIsRequest(false);
      }
    }
  }, [asList]);

  const changeBrandCode = (code: string | undefined) => {
    if (code === undefined) return;

    let value = "";

    if (code.toUpperCase().startsWith("M")) {
      value = "MLB";
    } else if (code.toUpperCase().startsWith("X")) {
      value = "Discovery";
    } else if (code.toUpperCase().startsWith("I")) {
      value = "MLB KIDS";
    } else if (code.toUpperCase().startsWith("A")) {
      value = "STRETCH ANGELS";
    } else if (code.toUpperCase().startsWith("V")) {
      value = "DUVETICA";
    } else if (code.toUpperCase().startsWith("ST")) {
      value = "Sergio Tacchini";
    } else {
      value = "SUPRA";
    }

    return value;
  };

  return (
    <>
      {isRequest ? (
        <>
          {asList?.map((info: AsVo, idx: any) => (
            <PaddingBox key={idx}>
              <HomeBgItem color="white">
                <Link to={"/as-detail/" + info.as_idx}>
                  <div>
                    <p className="title">
                      <span className="brand_name">{changeBrandCode(info.store_id)}</span>
                      {info.store_name}
                    </p>
                    <p className="text">{info.contents}</p>
                    <p className="date">{info.insert_date ? moment(info.insert_date).format("YYYY.MM.DD") : "-"}</p>
                  </div>
                  {info.es_approval_code_name && (
                    <div className="status">
                      <p
                        className={
                          info.es_approval_code_id === "EAC_100"
                            ? "active"
                            : info.es_approval_code_id === "EAC_0" || info.es_approval_code_id === "EAC_20"
                            ? "warning"
                            : ""
                        }
                      >
                        {info.es_approval_code_name}
                      </p>
                    </div>
                  )}
                </Link>
              </HomeBgItem>
            </PaddingBox>
          ))}
        </>
      ) : (
        <HomeBgItem>
          <p className="noData">등록해야 할 견적서가 없습니다.</p>
        </HomeBgItem>
      )}
    </>
  );
};

const PaddingBox = styled.div`
  padding-bottom: 8px;
  &:last-child {
    padding-bottom: 40px;
  }
`;

export default ComEstimateItem;
